import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSmartModalService } from 'ngx-smart-modal';
@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {

 
  constructor(public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, public http: HttpClient, private router: Router) {this.profileGet(); }
  mobileNumber = '';
  newPassword = '';
  newPasswordAgain = '';
  currencyChoice = '';
  passShort: boolean = false;
  loadingBox: boolean = true;
  loaded: boolean =  false;
  name = '';
  showPassReset: boolean = true;
  showUserReset: boolean = false;
  preferredCountries = [
    {"country":"South Africa", "code":'za', "dialcode":"+27"},
    {"country":"Nigeria", "code":'ng', "dialcode":"+97"},
    {"country":"Tunisia", "code":'tu', "dialcode":"+22"},
    {"country":"Egypt", "code":'eg', "dialcode":"+20"}
  ];
  public profileGet() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/getCurrentProfile',{
      headers:myheader
    })
    .subscribe(
      data => {
        this.mobileNumber = data['phoneNumber'];
        
      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
  );
  }

  public changeAccountInfo() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      this.mobileNumber = this.mobileNumber.replace(' ', '').substring(1);
     this.http.get('https://api-staging.videyo.tv/endpoint/saveProfileUpdate?username='+encodeURIComponent(this.mobileNumber.trim())+'&currencyID='+this.currencyChoice+'&name='+this.name, {
      headers:myheader
    })
    .subscribe(
      data => {
        this.showPassReset = true;
        this.showUserReset = false;
        this.mobileNumber = data['phoneNumber'];

      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
  );
  }
  refresh(): void {
    window.location.reload();
}
  public forgotUser() {
    this.showPassReset = false;
    this.showUserReset = false;
    if (this.newPassword.length < 6 || this.newPasswordAgain.length < 6 ) { 
      this.passShort = true;
    }
    else {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/manage/resetPassword?username='+this.mobileNumber+'&newPassword='+this.newPassword+'&newPasswordAgain='+this.newPasswordAgain,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.router.navigate(["/"]);
      },
      error => {
        console.log('ERROR:');
        console.log(error);}
  );
  }
}
  onMobNumKeyUp(event: any) {
    this.mobileNumber = event.target.value;
    
  }
  onNameKeyUp(event: any) {
    this.name = event.target.value;
    
  }
 
  onPasswordKeyUp(event: any) {
    this.newPassword = event.target.value;
    
  }
  onPasswordDoubleKeyUp(event: any) {
    this.newPasswordAgain = event.target.value;
    
  }
  onCurrencyChoice(event: any) {
    this.currencyChoice = event.target.value;
  }
  ngOnInit() {

    this.loadingBox = false;
    this.loaded = true;
  }

}
